import { jsPDF } from "jspdf";
import "../../../Assets/ptags/fonts/Montserrat-Bold";
import "../../../Assets/ptags/fonts/Montserrat-ExtraBold";
import "../../../Assets/ptags/fonts/Montserrat-Black";
import "../../../Assets/ptags/fonts/Montserrat-ExtraBoldItalic";
import "../../../Assets/ptags/fonts/Montserrat-BoldItalic";
import "../../../Assets/ptags/fonts/anton";
import { getAdjustedPrice ,generateBarcodeBase64} from "../../../Services/Api";

const now = new Date();
const timestamp = now
  .toISOString()
  .replace(/[:.]/g, '-')
  .replace('T', '_')
  .split('Z')[0];


export const generatePDFOpt2_TwoCols = (sectionsData, bannerImg, withBarCode) => {

    console.log(sectionsData, "sectionss");

    const pageWidth = 816;
    const pageHeight = 1056;

    const doc = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: [pageWidth, pageHeight],
    });

    const sectionWidth = pageWidth / 2;
    const sectionHeight = pageHeight / 2;
    const bannerImgHeight = 50;
    const maxSectionsPerPage = 4;

    let currentSection = 0;

    while (currentSection < sectionsData.length) {
        if (currentSection > 0) doc.addPage();

        const sectionsOnThisPage = Math.min(maxSectionsPerPage, sectionsData.length - currentSection);

        for (let i = 0; i < sectionsOnThisPage; i++) {
            const sectionIndex = currentSection + i;
            const section = sectionsData[sectionIndex];
            console.log(section, "each sec")
            if (!section) continue;

            const col = i % 2;
            const row = Math.floor(i / 2);
            const xPos = col * sectionWidth;
            const yPos = row * sectionHeight;

            const productImageUrl = section.image;
            const name = section.name || "";
            const sku = "Model#" + (section.sku || "");
            const variation = section.variations?.[0]
            const sale_price = variation?.sale_price || 0;
            const was_price = variation?.regular_price || 0;

            // Banner
            const bannerImgWidth = sectionWidth - 5;
            doc.addImage(bannerImg, "JPEG", xPos + 2.5, yPos, bannerImgWidth, bannerImgHeight);

            // Main Image
            const imgY = yPos + bannerImgHeight + 5;
            const imgHeight = sectionHeight * 0.65;
            if (productImageUrl) {
                doc.addImage(productImageUrl, "JPEG", xPos + 5, imgY, sectionWidth - 10, imgHeight);
            }

            // Overlay Name & SKU (top-right of image)
            doc.setFont("Montserrat-Bold", "bold");
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(9);
            doc.text(name, xPos + sectionWidth - 8, imgY + 14, { align: "right" });

            doc.setFontSize(8);
            doc.setFont("helvetica", "normal");
            doc.text(sku, xPos + sectionWidth - 8, imgY + 24, { align: "right" });

            // Bottom Container
            const bottomBoxY = imgY + imgHeight + 5;
            const bottomBoxHeight = sectionHeight - (bottomBoxY - yPos) - 5;
            const bottomBoxWidth = sectionWidth - 10;
            const bottomBoxX = xPos + 5;

            // Gap between two halves
            const gap = 6;
            const availableWidth = bottomBoxWidth - gap;
            const halfWidth = availableWidth / 2;

            // LEFT half border
            doc.setLineWidth(2);
            doc.setDrawColor(71, 74, 119);
            doc.rect(bottomBoxX, bottomBoxY, halfWidth, bottomBoxHeight, "S");

            // RIGHT half border
            const rightBoxX = bottomBoxX + halfWidth + gap;
            doc.rect(rightBoxX, bottomBoxY, halfWidth, bottomBoxHeight, "S");

            // LEFT content center
            const leftCenterX = bottomBoxX + (halfWidth / 2);
            const leftCenterY = bottomBoxY + (bottomBoxHeight / 2);

            // LEFT content: "Was" + Big Price
            const text2 = "was $" + was_price;
            doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(16);
            const text2Width = doc.getTextWidth(text2);
            doc.text(text2, leftCenterX - (text2Width / 2), leftCenterY - 15);

            const text3 = "$" + sale_price;
            doc.setFont("Montserrat-Black", "normal");
            doc.setTextColor(253, 0, 0);
            doc.setFontSize(50);
            const text3Width = doc.getTextWidth(text3);
            doc.text(text3, leftCenterX - (text3Width / 2), leftCenterY + 30);

            // RIGHT content center
            const rightCenterX = rightBoxX + (halfWidth / 2);
            let currentY = bottomBoxY + 25;

            const text1_main = "$" + getAdjustedPrice((sale_price !== 0 && sale_price !== "") ? sale_price : was_price).toString();
            const text1_suffix = "/week";

            doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
            doc.setFontSize(20);
            const width_main = doc.getTextWidth(text1_main);

            doc.setFont("helvetica", "normal");
            doc.setFontSize(12);
            const width_suffix = doc.getTextWidth(text1_suffix);

            const totalWidth = width_main + width_suffix + 2;
            const combinedTextX = rightCenterX - (totalWidth / 2);

            doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
            doc.setTextColor(253, 0, 0);
            doc.setFontSize(20);
            doc.text(text1_main, combinedTextX - 5, currentY);

            doc.setFont("helvetica", "bold");
            doc.setTextColor(61, 124, 157);
            doc.setFontSize(18);
            doc.text(text1_suffix, combinedTextX + width_main + 2, currentY);

            // Details under it — split into two lines
            currentY += 12;
            doc.setFont("helvetica", "normal");
            doc.setTextColor(151, 68, 131);
            doc.setFontSize(10);
            doc.text(
                ["Subject to approval.", "Some restrictions apply"],
                rightCenterX,
                currentY,
                { align: "center" }
            );

            currentY += 28;
            doc.setFont("helvetica", "bold");
            doc.setTextColor(136, 194, 87);
            doc.setFontSize(14);
            doc.text("NO CREDIT 0 DOWN", rightCenterX, currentY, { align: "center" });

            currentY += 18;
            doc.setFont("helvetica", "bold");
            doc.setTextColor(56, 112, 151);
            doc.setFontSize(14);
            doc.text("100 DAYS NO INTEREST", rightCenterX, currentY, { align: "center" });

            // Draw dashed lines between sections (horizontal & vertical)
            doc.setLineWidth(1);
            doc.setDrawColor(0, 0, 0);
            doc.setLineDashPattern([5, 3], 0);

            // Horizontal dashed line (between top & bottom rows)
            if (row === 0) {
                const yDash = yPos + sectionHeight;
                doc.line(xPos, yDash - 2, xPos + sectionWidth, yDash - 2);
            }

            // Vertical dashed line (between left & right columns)
            if (col === 0) {
                const xDash = xPos + sectionWidth;
                doc.line(xDash, yPos, xDash, yPos + sectionHeight);
            }

            // Reset dash to solid
            doc.setLineDashPattern([], 0);
        }

        // ==========================================
        // BACKSIDE: Barcode Page (2-col × 2-row grid)
        // ==========================================
        if (withBarCode === true) {
            doc.addPage();

            // Dashed guidelines matching front grid (1 vertical + 1 horizontal)
            doc.setLineDashPattern([5, 3], 0);
            doc.setDrawColor(0);
            doc.setLineWidth(1);

            // HORIZONTAL LINE (between row 0 & row 1)
            doc.line(0, pageHeight / 2, pageWidth, pageHeight / 2);

            // VERTICAL LINE (between col 0 & col 1)
            doc.line(pageWidth / 2, 0, pageWidth / 2, pageHeight);

            doc.setLineDashPattern([], 0); // reset dash before content

            for (let i = 0; i < sectionsOnThisPage; i++) {
                const sectionIndex = currentSection + i;
                const section = sectionsData[sectionIndex];
                if (!section) continue;

                const col = i % 2;
                const row = Math.floor(i / 2);
                const xPos = col * sectionWidth;
                const yPos = row * sectionHeight;

                const rectX = xPos + 2.5;
                const rectY = yPos + 5;
                const rectW = sectionWidth - 5;
                const rectH = sectionHeight - 10;

                // ==========================================
                // HEADER: Product name + underline
                // ==========================================
                const mainProductName = (section?.name || "") + " (Bar Codes)";

                doc.setFont("Montserrat-Bold", "bold");
                doc.setFontSize(14);
                const nameWidth = doc.getTextWidth(mainProductName);

                const startX = rectX + ((rectW - nameWidth) / 2);
                const headerTextY = rectY + 20;

                doc.setTextColor(0, 0, 0);
                doc.text(mainProductName, startX, headerTextY, { align: "left" });

                doc.setLineWidth(1);
                doc.setDrawColor(0, 0, 0);
                doc.setLineDashPattern([], 0);
                const underlineY = headerTextY + 12;
                doc.line(rectX - 2.5, underlineY, rectX + rectW, underlineY);

                // ==========================================
                // BUILD ITEM LIST
                // ==========================================
                const variations = section?.variations || [];
                const groupItems = variations.slice(1);
                const individuals = section?.individuals || [];

                const mainBlock = [
                    {
                        value: variations?.[0]?.value,
                        sku: section?.sku,
                        price: null,
                    },
                    ...groupItems.map(v => ({
                        value: v?.value,
                        sku: v?.sku,
                        price: v?.sale_price,
                    }))
                ];

                const indBlock = individuals
                    .filter(v => v?.inputValue && v.inputValue.trim() !== "" && v?.sku && v.sku.trim() !== "")
                    .map(v => ({
                        value: v?.inputValue,
                        sku: v?.sku,
                        price: v?.p_price,
                    }));

                const allItems = [...mainBlock];
                if (indBlock.length > 0) {
                    allItems.push(...indBlock);
                }

                const totalItems = allItems.length;
                if (totalItems === 0) continue;

                const columnCount = totalItems > 9 ? 2 : 1;
                const itemsPerColumn = 7;

                const colWidth = (rectW - 10) / columnCount;
                const columnsX = Array.from({ length: columnCount }, (_, i) =>
                    rectX + 5 + i * colWidth
                );

                const columnY = Array(columnCount).fill(underlineY + 20);

                // ==========================================
                // RENDER EACH ITEM WITH BARCODE
                // ==========================================
                const renderItem = (item, colIndex, globalIndex) => {
                    const x = columnsX[colIndex];
                    let y = columnY[colIndex];

                    if (item.isHeading) {
                        y += 5;
                        doc.setFont("Montserrat-Bold", "bold");
                        doc.setFontSize(10);
                        doc.setTextColor(71, 74, 119);
                        doc.text(item.value, x, y);

                        const headingWidth = doc.getTextWidth(item.value);
                        doc.setLineWidth(1);
                        doc.setDrawColor(71, 74, 119);
                        doc.line(x, y + 3, x + headingWidth, y + 3);

                        columnY[colIndex] = y + 18;
                        return;
                    }

                    // Variation label
                    doc.setFont("Montserrat-Bold", "bold");
                    doc.setFontSize(8);
                    doc.setTextColor(0, 0, 0);
                    doc.text(item.value || "", x, y);

                    const labelWidth = doc.getTextWidth(item.value || "");

                    // DEFAULT badge on first item
                    if (globalIndex === 0 && item.value) {
                        const badgeText = "DEFAULT";
                        doc.setFontSize(5);
                        const bTextWidth = doc.getTextWidth(badgeText);
                        const bPaddingX = 2;
                        const bPaddingY = 1;
                        const bWidth = bTextWidth + (bPaddingX * 2);
                        const bHeight = 8 + (bPaddingY * 2);
                        const bX = x + labelWidth + 4;
                        const bY = y - 8.5;

                        doc.setFillColor(40, 142, 169);
                        doc.roundedRect(bX, bY, bWidth, bHeight, 2, 2, 'F');

                        doc.setFont("Montserrat-Bold", "bold");
                        doc.setTextColor(255, 255, 255);
                        doc.text(badgeText, bX + bPaddingX, bY + 6.4);

                        doc.setFontSize(8);
                    }

                    // Price (red, right of label)
                    doc.setFontSize(8);
                    doc.setTextColor(255, 0, 0);
                    doc.text(item.price ? `$${item.price}` : "", x + labelWidth + 10, y);

                    y += 10;

                    // SKU Line
                    doc.setFont("Montserrat-Bold", "bold");
                    doc.setTextColor(0, 0, 0);
                    doc.text(item.sku || "", x, y);

                    // Barcode
                    if (item.sku) {
                        const barcodeImg = generateBarcodeBase64(item.sku);
                        doc.addImage(
                            barcodeImg,
                            "PNG",
                            x,
                            y,
                            colWidth - 10,
                            50
                        );
                        y += 35;
                    }

                    columnY[colIndex] = y + 32;
                };

                allItems.forEach((item, index) => {
                    let colIndex = Math.floor(index / itemsPerColumn);

                    if (item.isHeading && (index % itemsPerColumn === itemsPerColumn - 1)) {
                        colIndex += 1;
                    }

                    const targetCol = colIndex >= columnCount ? columnCount - 1 : colIndex;
                    renderItem(item, targetCol, index);
                });
            }
        }

        currentSection += sectionsOnThisPage;
    }

    doc.save(`price-tags_${timestamp}.pdf`);
};